import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    importResult: [],
    lastDateRange: {
      start: moment().add('-1', 'd').toDate(),
      end: moment().toDate()
    }
  },
  getters: {
    user: state => state.user,
    lastDateRange: state => state.lastDateRange
  },
  mutations: {
    setUser(state, user) {
      state.user = user
      if (user) {
          localStorage.user = JSON.stringify(user)
      } else {
          delete localStorage.user
      }
    },
    setLastDateRange(state, lastDateRange) {
      state.lastDateRange = lastDateRange
    }
  },
  actions: {

  }
})
